import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "txt_field" }
const _hoisted_2 = ["required"]
const _hoisted_3 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, null, -1)




export default /*#__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: /*#__PURE__*/_mergeModels({
    name: {},
    required: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const model = _useModel<string>(__props, "modelValue")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      required: _ctx.required,
      placeholder: " "
    }, null, 8, _hoisted_2), [
      [_vModelText, model.value]
    ]),
    _createElementVNode("label", null, [
      _createTextVNode(_toDisplayString(_ctx.t(_ctx.name)) + " ", 1),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("small", _hoisted_3, "*"))
        : _createCommentVNode("", true)
    ]),
    _hoisted_4
  ]))
}
}

})